import MainPageWrapper from '../../global/components/MainPageWrapper'
import TechnicianAssistantContent from '../components/content/TechnicianAssistantContent'

function TechnicianAssistantMain() {
  return (
    <MainPageWrapper title='Technician Assistant'>
      <TechnicianAssistantContent />
    </MainPageWrapper>
  )
}

export default TechnicianAssistantMain
